import type { FC, ReactElement } from 'react';
import { useContext } from 'react';

import { useHideCurrency } from '../../store/compositeSelectors/useHideCurrency';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useGameStateSlice } from '../../store/slices/game/selectors';
import { useWinners } from '../../store/slices/game/selectors';
import { useSettingsSlice } from '../../store/slices/settings/selectors';
import { PassiveComponentContext } from '../context';

import { WinnersList } from './winnersList';

export const WinnersListConnected: FC = (): ReactElement => {
  const currency = useGameStateSlice.getCurrency();
  const locale = useSettingsSlice.currentLanguage();
  const userId = useConfigSlice.playerConfig()?.userId;
  const winnersTotal = useGameStateSlice.getWinnersTotal();
  const playAreaSize = useConfigSlice.playAreaSize();
  const gameHeaderOverlayHeight = useConfigSlice.gameHeaderOverlayHeight();
  const isPassive = useContext(PassiveComponentContext);

  const hideCurrency = useHideCurrency();
  const winners = useWinners();

  return (
    <WinnersList
      currentUser={userId ?? ''}
      currency={currency ?? ''}
      hideCurrency={hideCurrency}
      locale={locale}
      winners={winners}
      winnersTotal={winnersTotal}
      playAreaSize={playAreaSize}
      gameHeaderOverlayHeight={gameHeaderOverlayHeight}
      isPassive={isPassive}
    />
  );
};
